import { isEmpty } from 'validator';
import { LinkField } from '@prismicio/client';

import { queryString } from '@preventx/prismic-services';

// Types
import { ApplicationRerouteUrlRequest } from '@/types/routing/applications';

// Constants
import { ApplicationRouter_PortalId } from '@/constants/routing';

// Services
import { applicationEnv } from '@/services/env/shared';

/** Will reroute the user to the appropriate application based on name and `PORTAL_ID` */
export const applicationRerouteUrl = ({
  params,
  application,
}: ApplicationRerouteUrlRequest): LinkField | null => {
  if (!application) {
    return null;
  }

  const { PortalId, ApplicationUrls } = applicationEnv();

  const {
    SecurePortalUrl,
    OrderTestBaseUrl,
    ConsultationBaseUrl,
    ServiceUserResultsBaseUrl,
  } = ApplicationUrls;

  const url = {
    'Order a Test': OrderTestBaseUrl,
    'Secure Portal': SecurePortalUrl,
    Consultation: ConsultationBaseUrl,
    'Service User Results': ServiceUserResultsBaseUrl,
  }[application];

  // Note : Possible this could still return empty if new items are added and not configured
  //        in here so this is a safety net
  if (isEmpty(url ?? '')) {
    return null;
  }

  const formattedUrl = url.replace(ApplicationRouter_PortalId, PortalId);

  return {
    link_type: 'Web',
    url: params ? queryString(formattedUrl, params) : formattedUrl,
  };
};
